document.addEventListener('DOMContentLoaded', () => {
  const animatedElements = document.querySelectorAll('.common-transform-show-p50');

  // 元素与视口有交集即认为可见
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight && rect.bottom > 0;
  }

  // 进入视口播放；离开视口重置，确保下次可再次播放
  function handleScroll() {
    animatedElements.forEach(element => {
      if (isInViewport(element)) {
        if (!element.classList.contains('active')) {
          setTimeout(() => {
            element.classList.add('active');
          }, 100);
        }
      } else {
        element.classList.remove('active');
      }
    });
  }

  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
});